import Skeleton from "react-loading-skeleton";

import { TimePeriod } from "api/generated/model";

import * as theme from "./table.css";
import { TableWidgetLayout } from "./tableWidgetLayout";

export function TableSkeleton({
    headerTitle,
    headerSubtitle,
}: {
    headerTitle: string;
    headerSubtitle: TimePeriod;
}) {
    return (
        <TableWidgetLayout
            headerTitle={headerTitle}
            headerSubtitle={headerSubtitle}
        >
            <div className={theme.skeletonRows}>
                <Skeleton count={4} height={30} />
            </div>
        </TableWidgetLayout>
    );
}
